import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import OwlCarousel from "react-owl-carousel";
import { domestic, others } from "./data";

const Home = () => {
  return (
    <Fragment>
      <Header name="Home" />
      <section className="p-top-110 p-bottom-40">
        <div className="intro-five">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <h4 className="display-2" style={{ fontSize: "2rem" }}>
                  ENSURING MAXIMUM CUSTOMER SATISFACTION
                </h4>
                <p>
                  The ability to understand customer needs, manufacturing and
                  supplying the best quality products at the right time at
                  competitive prices are the qualities that have made us the
                  most preferred and sustainable supplier to our valuable
                  customers.
                </p>
                <a href="#about" className="btn btn-secondary">
                  Scroll Down
                </a>
              </div>
              <div className="col-md-6">
                <div className="shape-wrapper img-shape-one">
                  <img src="img/simg-1.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="p-top-110">
        <div className="testimonial-carousel-six-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-10 offset-lg-1">
                <div className="testimonial-carousel-six owl-carousel">
                  <div className="carousel-single">
                    <img
                      src="img/used/D-Tirupathi-Raju.jpg"
                      alt=""
                      className="rounded-circle"
                    />
                    <h5>Mr. D. Tirupathi Raju</h5>
                    <p style={{ maxHeight: 250 }}>
                      He has more than 30 years of experience in different
                      leading industries where he gained knowledge in Product
                      Marketing, Industry Management, Agricultural activities,
                      Horticulture etc. He has worked as Chairman of CII for
                      Visakhapatnam Region, and also held the position of Vice
                      President for All India Starch Manufacturer’s Association
                      and was also a director of Vizagapatam Chamber of
                      Commerce. He is now the Executive Chairman of Vijaynagar
                      Biotech Private Limited.
                    </p>
                  </div>
                  <div className="carousel-single">
                    <img
                      src="img/used/D-Vivekananda-Raju.jpg"
                      alt=""
                      className="rounded-circle"
                    />
                    <h5>Mr. D. Vivekananda Raju</h5>
                    <p>
                      He has more than 20 years of experience in the areas of
                      procurement and marketing of agriculture based products
                      and he is currently Managing Director of M/s Vijaynagar
                      Biotech Private Limited.
                    </p>
                  </div>
                  <div className="carousel-single">
                    <img
                      src="img/used/D-Raghava-Raju.jpg"
                      alt=""
                      className="rounded-circle"
                    />
                    <h5>Mr. D. Raghava Raju</h5>
                    <p>
                      He has more than 27 years of experience in Factory
                      Maintenance, Project Implementation aspect and Agriculture
                      based product marketing. He is currently the Technical
                      Director of Vijaynagar Biotech Private Limited.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <section class="p-top-110">
        <h3 className="text-center">Director's Profile</h3>
        <div class="testimonial-carousel-six-wrapper">
          <div class="container">
            <div class="row">
              <div class="col-lg-10 offset-lg-1">
                <OwlCarousel
                  class="testimonial-carousel-six owl-carousel"
                  items={1}
                >
                  <div class="carousel-single">
                    <img
                      src="img/client6.jpg"
                      // style={{ display: "inline-block", width: "auto" }}
                      alt=""
                      class="rounded-circle"
                    />
                    <h5>Amanda Richards</h5>
                    <span class="sub-text">Customer Relations</span>
                    <p>
                      Demons trave runt lectores legere lius quod ii legunt
                      saepius clary tyitas Investig ationes demon trave rungt.
                      Investig ationes trave lector ompanies that responsibility
                      in our core business. We work systematically to integrate
                      corporate responsibility in our core business.
                    </p>
                  </div>

                  <div class="carousel-single">
                    <img src="img/client6.jpg" alt="" class="rounded-circle" />
                    <h5>Amanda Richards</h5>
                    <span class="sub-text">Customer Relations</span>
                    <p>
                      Demons trave runt lectores legere lius quod ii legunt
                      saepius clary tyitas Investig ationes demon trave rungt.
                      Investig ationes trave lector ompanies that responsibility
                      in our core business. We work systematically to integrate
                      corporate responsibility in our core business.
                    </p>
                  </div>

                  <div class="carousel-single">
                    <img src="img/client6.jpg" alt="" class="rounded-circle" />
                    <h5>Amanda Richards</h5>
                    <span class="sub-text">Customer Relations</span>
                    <p>
                      Demons trave runt lectores legere lius quod ii legunt
                      saepius clary tyitas Investig ationes demon trave rungt.
                      Investig ationes trave lector ompanies that responsibility
                      in our core business. We work systematically to integrate
                      corporate responsibility in our core business.
                    </p>
                  </div>
                </OwlCarousel>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <section
        id="about"
        className="content-block section-padding section-bg content--block5"
      >
        <div className="container">
          <div className="row d-flex text-md-center text-lg-left align-items-center">
            <div className="col-lg-6 margin-md-60">
              <img src="img/map.png" alt="" />
            </div>
            <div className="col-lg-5 offset-lg-1">
              <h3 className="m-bottom-20">About Us</h3>
              <p>
                Vijayanagar Biotech Private Limited was formed and incorporated
                with registrar of companies, on 26th May, 2004 to manufacture
                Maize Starch, Modified Starches and by-products from Maize i.e.,
                Maize Germs, Maize Gluten, Fiber, Cattle Feed and starch
                derivatives. Founded by Mr. D. Ranga Raju, the project was set
                up at Kotha Kopperla, Pusapatiregu Mandal, Vizianagaram and
                Andhra Pradesh. The company is professionally managed by the
                board of directors and technocrats with rich experience in
                different walks of business profiles.
              </p>
              <p>
                Currently, the plant has a Maize grinding capacity of 350 tpd.
                All the equipments are made up of stainless steel, adopting the
                latest international technological developments. Our products
                include modified starches such as oxidized, cationic,
                esterified, thin boiling, pre-gelatinized and pharma grade which
                are manufactured with slurry method, witnessing exponential
                growth with its full capacity utilization.
              </p>
              <p>
                <strong>VISION: </strong> To be an Independent Global Player in
                Agricultural Processing & Value addition Industries <br />
                <strong>MISSION: </strong>
                Giving Quality Products with a firm commitment towards customer
                satisfaction
              </p>
              <a href="#productappl" className="btn btn-primary btn-arrow mt-3">
                Product Applications <i className="la la-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="p-top-80 p-bottom-110" id="productappl">
        <div className="tab tab--2">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="tab_nav2">
                  <ul
                    className="nav justify-content-center"
                    id="myTab"
                    role="tablist"
                  >
                    <li className="nav-item">
                      <a
                        className="nav-link active"
                        id="info_tab1"
                        data-toggle="tab"
                        href="#info"
                        role="tab"
                        aria-controls="info"
                        aria-selected="true"
                      >
                        Paper Grade Starches
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        id="info_tab2"
                        data-toggle="tab"
                        href="#info2"
                        role="tab"
                        aria-controls="info2"
                        aria-selected="false"
                      >
                        Adhesive Grade Starches
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        id="info_tab3"
                        data-toggle="tab"
                        href="#info3"
                        role="tab"
                        aria-controls="info3"
                        aria-selected="false"
                      >
                        Additional Range of Products
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="tab-content tab--content2" id="tabcontent2">
            <div
              className="tab-pane animated fadeIn show active"
              id="info"
              role="tabpanel"
              aria-labelledby="info_tab1"
            >
              <div className="container">
                <div className="row align-items-center">
                  <div className="col-lg-5">
                    <div className="tab_text_module">
                      {/* <p className="tab_text_module__subtitle">
                        Trusted Business Consultancy
                      </p> */}
                      <h2>
                        We offer a wide range of products with various
                        applications
                      </h2>
                      <p>
                        The history of starch in paper making dates back to 6000
                        years. Starch is applied in the wet-end to the size
                        press and can also be used for coating and as calendar
                        starch. Proper cooking & complete hydration of a starch
                        molecule is essential to perform on its desired
                        application.
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-6 offset-lg-1">
                    <div className="video-single">
                      <figure>
                        <div className="v_img">
                          <img
                            src="img/used/simg-2.png"
                            alt=""
                            className="rounded"
                          />
                        </div>
                        <figcaption className="d-flex justify-content-center align-items-center shape-wrapper img-shape-two">
                          {/* <a
                            href="https://www.youtube.com/watch?v=omaTcIbwt9c"
                            className="video-iframe play-btn play-btn--lg play-btn--primary"
                          >
                            <img
                              src="img/svg/play-btn.svg"
                              alt=""
                              className="svg"
                            />
                          </a> */}
                        </figcaption>
                      </figure>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="tab-pane animated fadeIn"
              id="info2"
              role="tabpanel"
              aria-labelledby="info_tab2"
            >
              <div className="container">
                <div className="row align-items-center">
                  <div className="col-lg-6">
                    <figure className="tab_image_module--left">
                      <img src="img/used/tab2img2.png" alt="" />
                    </figure>
                  </div>

                  <div className="col-lg-5 offset-lg-1">
                    <div className="tab_text_module">
                      <h2>Adhesive Grade Starches</h2>
                      <p>
                        Starch Adhesives is a modified starch formulation with
                        excellent track and adhesiveness. They are ideal for
                        bonding paper-based materials and are also used for
                        corrugated board making and for tube winding. The raw
                        material is relatively low cost, readily available in
                        good quality grades and biodegradable.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="tab-pane animated fadeIn"
              id="info3"
              role="tabpanel"
              aria-labelledby="info_tab3"
            >
              <div className="container">
                <div className="row align-items-center">
                  <div className="col-lg-5 ">
                    <div className="tab_text_module">
                      <h2>Additional Range of Products</h2>
                      <p>
                        Apart from the standard range of products, we also have
                        extra varieties available in stock which are further
                        categorized into 3 variants, i.e., Maize Starch, Gypsum
                        Board Starch and Pregel Starch.
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-6 offset-lg-1">
                    <figure className="tab_image_module--right">
                      <img src="img/used/tab2img3.png" alt="" />
                    </figure>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bt1 services_area p-top-100 p-bottom-70">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="section_title text-center">
                <h1>Our Products</h1>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-sm-6">
              <div className="icon-box-five">
                <h6>PAPER GRADE STARCHES</h6>
                <ul className="arrow--list4">
                  <li className="list-item arrow-list4">Wet-End Starches</li>
                  <li className="list-item arrow-list4">Spray Starches</li>
                  <li className="list-item arrow-list4">Surface Starches</li>
                  <li className="list-item arrow-list4">Coating Starches</li>
                </ul>
                <p></p>
                <Link
                  to="/products"
                  className="btn btn-sm btn-outline-secondary"
                >
                  See Details
                </Link>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <div className="icon-box-five">
                <h6>ADHESIVE GRADE STARCHES</h6>
                <ul className="arrow--list4">
                  <li className="list-item arrow-list4">VijiCol</li>
                  <li className="list-item arrow-list4">Vijibond</li>
                  <li className="list-item arrow-list4">VijiSack P20</li>
                </ul>
                <p></p>
                <Link
                  to="/products"
                  className="btn btn-sm btn-outline-secondary"
                >
                  See Details
                </Link>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <div className="icon-box-five">
                <h6>ADDITIONAL RANGE OF PRODUCTS</h6>
                <ul className="arrow--list4">
                  <li className="list-item arrow-list4">Maize Starch</li>
                  <li className="list-item arrow-list4">Vijigyp</li>
                  <li className="list-item arrow-list4">
                    DRILLING GRADE (VIJIDRILL – DS & CMS)
                  </li>
                </ul>
                <p></p>
                <Link
                  to="/products"
                  className="btn btn-sm btn-outline-secondary"
                >
                  See Details
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bt1 services_area p-top-100 p-bottom-70">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="section_title text-center">
                <h1>Our Clients</h1>
              </div>
            </div>
          </div>
        </div>
        <div className="container m-top-20">
          <div className="section_title text-center">
            <h5>Domestic Clients</h5>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <OwlCarousel
                className="logo-carousel-one owl-carousel"
                margin={10}
                items={window.innerWidth > 500 ? 5 : 1}
                autoPlay
              >
                {domestic.map((domest) => (
                  <div className="carousel-single" key={domest}>
                    <img src={domest} alt="" />
                  </div>
                ))}
              </OwlCarousel>
            </div>
          </div>

          <div className="m-bottom-60"></div>

          <div className="section_title text-center">
            <h5>International Clients</h5>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <OwlCarousel
                className="logo-carousel-one owl-carousel"
                margin={10}
                items={window.innerWidth > 500 ? 5 : 1}
                autoPlay
              >
                {others.map((domest) => (
                  <div className="carousel-single" key={domest}>
                    <img src={domest} alt="" />
                  </div>
                ))}
              </OwlCarousel>
            </div>
          </div>
        </div>
      </section>

      <section className="bt1" id="brochure">
        <iframe
          src="https://www.flipbookpdf.net/web/site/7f9ad11a8f99190bb2cd333ce07d011bb13a3a5b202209.pdf.html"
          width="900"
          height="637"
          frameBorder="0"
          title="brochure"
          allowFullScreen
        ></iframe>

        <div
          className="row"
          style={{ justifyContent: "center", alignItems: "center" }}
        >
          <a
            className="btn btn-secondary btn-sm btn-icon icon-left m-5"
            style={{ alignSelf: "center" }}
            href="Vijaynagar_Biotech.pdf"
            download
          >
            Download (PDF)
          </a>
          <Link
            className="btn btn-secondary btn-sm btn-icon icon-left"
            style={{ alignSelf: "center" }}
            to="/brochure"
          >
            View (PDF)
          </Link>
        </div>
      </section>

      {/* <section
        className="contact-split d-flex align-items-center bt1"
        id="contact"
      >
        <div className="g-maps">
          <div className="map" id="map2"></div>

          <div className="map-top">
            <ul className="icon-list--three">
              <li className="icon-list2 d-flex">
                <div className="icon">
                  <i className="la la-headphones"></i>
                </div>
                <div className="contents">
                  <h6>+91 8912731634</h6>
                </div>
              </li>

              <li className="icon-list2 d-flex">
                <div className="icon">
                  <i className="la la-envelope"></i>
                </div>
                <div className="contents">
                  <h6>info@vbtpl.com</h6>
                </div>
              </li>

              <li className="icon-list2 d-flex">
                <div className="icon">
                  <i className="la la-map-marker"></i>
                </div>
                <div className="contents">
                  <h6>Siripuram, Visakapatnam</h6>
                  <span className="sub-text">
                    Padmavathi Towers, Balaji Nagar
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-5 offset-lg-7">
              <div className="form-wrapper">
                <div className="m-bottom-10">
                  <div className="divider divider-simple text-left">
                    <h3>Let&#39;s Get In Touch</h3>
                  </div>
                </div>
                <p className="m-bottom-30">
                  Thank you for taking the time to visit our website. Please
                  feel free to drop your details below in case you have any
                  queries or would like to find out more about us. You can also
                  share your experience as a visitor. We will take your
                  suggestions into account so as to continuously improve our
                  services.
                </p>
                <form action="#">
                  <input
                    type="text"
                    className="form-control form-outline mb-4"
                    placeholder="Name"
                    required
                  />
                  <input
                    type="email"
                    className="form-control form-outline mb-4"
                    placeholder="Email"
                    required
                  />
                  <textarea
                    className="form-control form-outline mb-4"
                    placeholder="Messages"
                    required
                  ></textarea>
                  <button className="btn btn-primary">Submit Now</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <div className="bt1"></div>
      <Footer />
    </Fragment>
  );
};

export default Home;
